import axios from "axios";

// การซื้อแพ็ก — BE: src/app/dent_cloud/controllers/billingController (spec §6)
//
// เรื่องเงินไม่ควรเด้ง toast กลางจอทับหน้าจ่ายเงิน หน้าซื้อแสดงข้อความเองแบบ inline
const QUIET = { skipGlobalErrorHandler: true };
// 403 ที่นี่เป็นเรื่องปกติ: ผู้ใช้ที่ไม่ใช่เจ้าของคลินิก/ผู้จัดการสาขาเปิดหน้านี้แล้วซื้อไม่ได้
// ไม่ควรโดนดีดออกไปหน้า /clinic แต่ควรเห็นข้อความว่าทำไมซื้อไม่ได้
const NO_REDIRECT = { skipPermissionRedirect: true };

const moduleBilling = {
  namespaced: true,
  actions: {
    /**
     * แคตตาล็อกแพ็กที่เปิดขาย + แพ็กปัจจุบันของสาขา
     *
     * ไม่ cache: ราคาอยู่ในฐานข้อมูลและเปลี่ยนได้โดยไม่ต้อง deploy การถือค่าเก่าไว้แปลว่า
     * หน้าจอโชว์ราคาหนึ่งแต่ตอนกดซื้อถูกเก็บอีกราคาหนึ่ง
     */
    async fetchPlans(_ctx, { clinicUrl, branchUrl }) {
      const res = await axios.get(
        `/api/branch/${clinicUrl}/${branchUrl}/billing/plans`,
        { ...QUIET, ...NO_REDIRECT }
      );
      return res.data.data || res.data;
    },

    /**
     * เริ่มซื้อ — คืน { orderNumber, webPaymentUrl }
     *
     * ผู้เรียกต้องพาผู้ใช้ไปที่ webPaymentUrl แล้วรอให้กลับมา **ห้ามถือว่าซื้อสำเร็จ**
     * จนกว่า fetchOrderStatus จะตอบ settled: true — สิทธิ์เปิดโดย webhook ฝั่ง server
     * ไม่ใช่โดยการที่ผู้ใช้เดินทางกลับมาถึงหน้าเรา
     */
    async createCheckout(_ctx, { clinicUrl, branchUrl, planCode, billingCycle, paymentMethod }) {
      const res = await axios.post(
        `/api/branch/${clinicUrl}/${branchUrl}/billing/checkout`,
        { planCode, billingCycle, paymentMethod },
        { ...QUIET, ...NO_REDIRECT }
      );
      return res.data.data || res.data;
    },

    /**
     * เลิกต่ออายุแพ็ก — **มีผลเมื่อจบรอบ ไม่ตัดกลางคัน และไม่คืนเงิน**
     *
     * คืน { planCode, status, endDate, daysRemaining, recurringCancellationPending }
     *
     * ผู้เรียกต้องดึง entitlements ใหม่หลังสำเร็จ ไม่งั้นทั้งแอปยังถือสถานะเก่าอยู่จน
     * กว่าจะเปลี่ยนสาขาหรือรีเฟรช — สถานะบนหน้าแพ็กจะขัดกับ gate ของหน้าอื่น
     */
    async cancelSubscription(_ctx, { clinicUrl, branchUrl }) {
      const res = await axios.post(
        `/api/branch/${clinicUrl}/${branchUrl}/billing/subscription/cancel`,
        {},
        { ...QUIET, ...NO_REDIRECT }
      );
      return res.data.data || res.data;
    },

    /** สถานะคำสั่งซื้อ — ถามซ้ำได้จนกว่า settled เป็น true */
    async fetchOrderStatus(_ctx, { clinicUrl, branchUrl, orderNumber }) {
      const res = await axios.get(
        `/api/branch/${clinicUrl}/${branchUrl}/billing/order/${orderNumber}`,
        { ...QUIET, ...NO_REDIRECT }
      );
      return res.data.data || res.data;
    },
  },
};

export default moduleBilling;
